var map = {
	"./favicon.ico": 4,
	"./favicon_114.png": 5,
	"./favicon_120.png": 6,
	"./favicon_144.png": 7,
	"./favicon_152.png": 8,
	"./favicon_167.png": 9,
	"./favicon_180.png": 10,
	"./favicon_57.png": 11,
	"./favicon_60.png": 12,
	"./favicon_72.png": 13,
	"./favicon_76.png": 14,
	"./favicon_fb.png": 15,
	"./windows_large.png": 16,
	"./windows_square.png": 17,
	"./windows_tiny.png": 18,
	"./windows_wide.png": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;